import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';

interface IProps {
    message: string;
    onClose?: () => void;
}

export const MessageModal: FunctionComponent<IProps> = ({ message, onClose: onModalClose }) => {
    const [isOpen, setIsOpen] = useState(true);
    const onClose = () => {
        setIsOpen(false);
        onModalClose?.();
    };

    return (
        <ZfDialog show={isOpen} size="s">
            <ZfDialogContent>{message}</ZfDialogContent>
            <ZfDialogFooter>
                <ZfTextButton slot="primary" size="medium" onClick={onClose}>
                    Close
                </ZfTextButton>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
